<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in errors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="CR Number"
          v-model="crNumber"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Name"
          v-model="name"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          type="date"
          label="Date Of Reciept"
          v-model="dateOfReciept"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          type="date"
          label="Due Date"
          v-model="dateDue"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          dark
          :loading="storing"
          @click="store"
        >Add</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { errorHandler } from '@/extra-functions/store.extra'
  import consumerLoanRepository from '@/repositories/consumer-loan.repository'
  // import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
  import searchDelay from '@/extra-functions/searchDelay.extra'

  const typing = searchDelay(300)

  export default {
    name: 'create-consumer-loan',
    props: {
      propConsumerId: String,
    },
    data () {
      return {
        crNumber: null,
        name: null,
        dateOfReciept: null,
        dateDue: null,
        errors: [],
        storing: false,
      }
    },
    computed: {
      storeId () {
        return this.$store.state.settings.storeId
      },
    },
    watch: {
      crNumber (val) {
        const regX = /\s/ig
        if (regX.test(val)) {
          typing(() => {
            this.crNumber = val.replace(regX, '')
          })
        }
      },
    },
    methods: {
      store () {
        if (!this.storing) {
          this.storing = true
          this.errors = []
          const id = this.propConsumerId
          const data = {
            id: this.crNumber,
            consumer_id: id,
            loanee_name: this.name,
            date_loaned: this.dateOfReciept,
            date_due: this.dateDue,
            store_id: this.storeId,
          }
          consumerLoanRepository.store(id, data)
            .then(() => { this.clearInputs() })
            .catch(errors => { this.errors = errorHandler(errors) })
            .then(() => { this.storing = false })
        }
      },
      clearInputs () {
        this.name = null
        this.date = null
      },
    },
  }
</script>
